/**
 * PartnerFence — keeps every partner login (supplier, printer, FC, warehouse)
 * inside its own portal.
 *
 * Wraps every route. For a signed-in partner (access levels 4 to 7) on any path
 * outside its own root it redirects to its board BEFORE the route renders, so
 * no staff, client or other-portal screen mounts and fires API calls the
 * server would refuse. Everyone else passes straight through, untouched.
 *
 * Usability only — the API is what actually enforces this.
 */
import type { ReactNode } from "react";
import { Navigate, useLocation } from "react-router-dom";

import { useAuth } from "@/contexts/AuthContext";
import { partnerRedirectFor } from "@/lib/auth/partnerAccess";

export const PartnerFence = ({ children }: { children: ReactNode }) => {
  const { user, loading } = useAuth();
  const { pathname } = useLocation();

  const to = !loading && user ? partnerRedirectFor(pathname, user.access_level) : null;
  if (to) return <Navigate to={to} replace />;
  return <>{children}</>;
};

export default PartnerFence;
